import { createContext } from 'react'

export interface ITeamContext {
  searchQuery: string
  setSearchQuery(value: string): void
}

export const TeamContext = createContext<ITeamContext>({
  searchQuery: '',
  setSearchQuery: () => {},
})
